import { SUBSCRIPTION_SERVICE_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import {
  SubscriptionV3PaymentIntentData,
  SubscriptionV3PaymentIntentResponse
} from './types/subscriptionV3/SubscriptionV3PaymentIntentResponse'
import { flowFetch } from '@dtx-company/app/shared/code/src/utils/flowFetch'
import { getRequestHeadersWithAuthHeader } from '../../components/org/utils'
import { migrateSubscriptionV3PaymentIntentResponseToSubscriptionV3PaymentIntentData } from './serialization/migrateSubscriptionV3'
import { subscriptionServiceV3ErrorHandler } from './subscriptionServiceV3ErrorHandler'

const getChangePaymentUrl = (subscriptionId: string): string =>
  `${SUBSCRIPTION_SERVICE_ENDPOINT}/v3/subscriptions/${subscriptionId}/change-payment-method`

export interface ChangePaymentMethodOptions {
  subscriptionId: string
  paymentMethodId: string
  token: string
}

export async function changePaymentMethodV3(
  options: ChangePaymentMethodOptions
): Promise<SubscriptionV3PaymentIntentData | undefined> {
  const { subscriptionId, token, ...body } = options
  const url = getChangePaymentUrl(subscriptionId)
  const headers = getRequestHeadersWithAuthHeader(token)
  const res = await flowFetch<SubscriptionV3PaymentIntentResponse>(
    'POST',
    url,
    { technicalArea: 'monetization' },
    {
      headers,
      body: JSON.stringify(body)
    },
    subscriptionServiceV3ErrorHandler
  )

  return res?.data
    ? migrateSubscriptionV3PaymentIntentResponseToSubscriptionV3PaymentIntentData(res.data)
    : undefined
}
